import { render, staticRenderFns } from "./SidebarStage.vue?vue&type=template&id=062d8048&scoped=true"
import script from "./SidebarStage.vue?vue&type=script&lang=js"
export * from "./SidebarStage.vue?vue&type=script&lang=js"
import style0 from "./SidebarStage.vue?vue&type=style&index=0&id=062d8048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d8048",
  null
  
)

export default component.exports